import styled from "styled-components";
import { Flex, Box } from "@edricphan2022/uikit";
import mediaQueries from "../../@uikit/theme/base";
import BgFaq from "../../assets/Home/FAQ/panner.png";
import BgBody from "../../assets/Home/BackGroundBody.svg";

// &::after {
//   content: "";
//   position: absolute;
//   top: -8%;
//   right: 10%;
//   width: 652px;
//   height: 600px;
//   background-image: url("/assets/home/bannerSvg.svg");
//   background-position: center;
//   background-size: cover;
//   background-repeat: no-repeat;
//   opacity: 1;
// }

export const BannerBox = styled(Box)`
  width: 100%;
  padding-top: 10px;
  position: relative;
  // background: linear-gradient(180deg, #fffef6 0%, rgba(251, 251, 243, 0) 100%);
  padding-top: 90px;
  display: flex;
  .query-title-header {
    font-size: 64px;
  }
  .posterOrbit {
    width: 50%;
    height: 100%;
    position: relative;
  }
  .backgroundPoster{
    position: absolute;
    top:0px;
    left:0px;
    right:0px;
    bottom:0px;
  }
  .PosterImg{
    width: 100%;
    height: 100%;
    transform: scale(1)
  }
  .Item1 {
    top: 50%;
    left: 50%;
    transform: translateY(-255%) translateX(-289%);
  }
  .Item2 {
    top: 50%;
    left: 50%;
    transform: translateY(-314%) translateX(160%);
  }
  .Item3 {
    top: 50%;
    left: 50%;
    transform: translateY(-183%) translateX(239%);
  }
  .Item4 {
    top: 50%;
    left: 50%;
    transform: translateY(0%) translateX(31%);
  }
  .Item5 {
    top: 50%;
    left: 50%;
    transform: translateY(112%) translateX(165%);
  }
  .Item6 {
    top: 50%;
    left: 50%;
    transform: translateY(121%) translateX(-346%);
  }


  ${mediaQueries.mediaQueries.xl}{
    .query-title-header {
      font-size: 50px;
    }
    .Item1{
      transform: translateY(-230%) translateX(-260%);
    }
    .Item2{
      transform: translateY(-290%) translateX(135%);
    }
    .Item3{
      transform: translateY(-143%) translateX(200%);
    }
    .Item4{
      transform: translateY(0%) translateX(25%);
    }
    .Item6{
      transform: translateY(120%) translateX(-340%);
    }
    .Item5{
      transform: translateY(100%) translateX(126%);
    }
  }
  

  ${mediaQueries.mediaQueries.md} {
    .query-title-header {
      font-size: 38px;
    }
    .heading-num {
      font-size: 32px;
    }
    .Item1{
      transform: translateY(-230%) translateX(-260%);
    }
    .Item2{
      transform: translateY(-290%) translateX(135%);
    }
    .Item3{
      transform: translateY(-143%) translateX(200%);
    }
    .Item4{
      transform: translateY(0%) translateX(25%);
    }
    .Item5{
      transform: translateY(100%) translateX(126%);
    }
    .Item6{
      transform: translateY(80%) translateX(-240%);
    }
    
  }


  @media (max-width: 768px) {
    .query-title-header {
      font-size: 40px;
    }
    .Item1{
      transform: translateY(-230%) translateX(-260%);
    }
    .Item2{
      transform: translateY(-290%) translateX(135%);
    }
    .Item3{
      transform: translateY(-143%) translateX(200%);
    }
    .Item4{
      transform: translateY(0%) translateX(25%);
    }
    .Item6{
      transform: translateY(100%) translateX(-340%);
    }
    .Item5{
      transform: translateY(100%) translateX(126%);
    }
  }
  @media (max-width: 760px) {
    .posterOrbit{
      display: none;
    }
  }
  }
`;

export const IConContainer = styled(Flex)`
  width: 60px;
  height: 60px;
  position: absolute;
  background: linear-gradient(to bottom, rgba(255, 144, 38), rgba(254, 201, 64));
  border-radius: 50%;
  box-shadow: 0 5px 10px 1px #ccaf47;
  display: flex;
  align-items: center;
  justify-content: center;
  .ItemImg {
    width: 100%;
    height: 100%;
    transform: scale(1.5);
    animation-name: rotate;
    animation-duration: 4s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }
  @keyframes rotate {
    0% {
      transform: rotateZ(0deg) scale(1.5);
    }
    100% {
      transform: rotateZ(360deg) scale(1.5);
    }
  }
  ${mediaQueries.mediaQueries.xl}{
    width: 50px;
    height: 50px;
  }
  ${mediaQueries.mediaQueries.md} {
    width: 45px;
    height: 45px;
  }
  @media only screen and (max-width: 768px){
    width: 30px;
    height: 30px;
  }
  
  }
`;

export const BannerFlexFloor = styled(Flex)<{ tranl?: any }>`
  height: 100%;
  width: 300%;
  transform: translateX(-${({ tranl }) => tranl}%);
  transition: all 0.3s linear;
`;

export const BannerFlex = styled(Flex)<{ top: number }>`
  width: 100%;
  height: 100%;
  display: flex !important;
  .Panner-Left {
    width: 50%;
  }
  .slick-dots {
    top: ${({ top }) => {
      return top - 40;
    }}px;
    left: -20%;
    transition: all 0.1s linear;
  }
  .Slider-Text-Box {
    opacity: 0;
  }
  .slick-active {
    .Slider-Text-Box {
      opacity: 1;
      transition: all 0.3s linear;
      transition-delay: 0.5s;
    }
  }
  .posterOrbit {
    display: flex;
    align-items: center;
    justify-content: center;
    .slick-active {
      img {
        opacity: 1;
        transition: all 0.3s linear;
        transition-delay: 0.5s;
      }
    }
    .slick-next,
    .slick-prev {
      display: none;
    }
  }
  .PosterBox {
    position: relative;
    height: 477px;
  }
  .Posterpanner {
    position: absolute;
    top: 50%;
    right: 0%;
    transform: translateY(-50%);
  }
  img {
    max-height: 477px;
    width: auto;
    margin: auto;
    opacity: 0;
  }

  ${mediaQueries.mediaQueries.xl} {
    /* flex-direction: column; */
    align-items: flex-start;
  }
  @media only screen and (max-width: 1560px) {
    .Panner-Left {
      width: 50%;
    }
  }
  @media only screen and (max-width: 1280px) {
    .slick-dots {
      bottom: -80%;
      left: -10%;
    }
  }
  @media only screen and (max-width: 1024px) {
    .slick-dots {
      bottom: -80%;
      left: 0%;
    }
  }
  @media only screen and (max-width: 767px) {
    max-height: ${({ top }) => {
      return top + 100;
    }}px;
    .posterOrbit {
      display: none;
    }
    .Panner-Left {
      width: 100%;
    }
  }
  @media only screen and (max-width: 404px) {
    .slick-dots {
      bottom: -60%;
      left: 10%;
    }
  }
  @media only screen and (max-width: 320px) {
    .slick-dots {
      bottom: -60%;
      left: 20%;
    }
  }
`;

export const FlexLeft = styled(Flex)`
  flex-direction: column;
  align-items: flex-start;
  height: inherit;
  padding-top: 50px;
  // position: relative;
`;

export const FlexRight = styled(Box)`
  position: relative;
  min-height: 300px;
  /* width: 100%; */

  /* .orbit-banner {
    position: absolute;
    max-width: initial;
    top: 0%;
    right: 0%;
  } */

  /* picture {
    position: absolute;
    top: -12%;
  } */
`;

export const BannerInfomation = styled(Flex)`
  margin-top: 10px;
  padding-bottom: 50px;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  h1,
  p {
    font-size: 40px;
    color: #333333;
    font-family: ManropeBold;
    font-weight: 700;
    line-height: 77px;
  }
  p {
    font-size: 24px;
    font-family: ManropeRegular;
    font-weight: 400;
    line-height: 35px;
  }
  div {
    width: 23%;
  }
  @media only screen and (max-width: 1280px) {
    P {
      font-size: 20px;
    }
  }
  @media only screen and (max-width: 1133px) {
    p {
      font-size: 14px;
      line-height: 24px;
    }
  }
  @media only screen and (max-width: 743px) {
    div {
      width: 40%;
      margin-bottom: 20px;
      :nth-child(3) {
        margin-bottom: 0px;
      }
      :nth-child(4) {
        margin-bottom: 0px;
      }
    }
  }
`;

export const BannerColumn = styled(Flex)`
  flex-direction: column;
  align-items: flex-start;
  overflow: hidden;
  position: relative;
  .slick-slider {
    width: 100%;
  }
  .slick-dots {
    button {
      :before {
        width: 10px;
        height: 3px;
        content: "";
        background-color: black;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
      }
    }
    .slick-active {
      button {
        :before {
          height: 10px;
          border-radius: 50%;
          border: 1px solid black;
          background-color: transparent;
        }
      }
    }
  }
`;

export const BoxBtnSlider = styled(Flex)`
  width: 62px;
  height: 48px;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  top: 50%;
  transform: translateY(30%) translateX(250%);
  .active {
    background-color: transparent;
    border: 1px solid #000000;
    height: 10px;
    border-radius: 50%;
  }
  button {
    width: 10px;
    height: 4px;
    background-color: #000000;
    border: none;
    outline: none;
  }
`;

export const BoxAboutUs = styled(Flex)`
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
`;

export const BoxBlockChain = styled(Flex)`
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 42px;
`;

/// blockchaindev

export const MintContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  width: 100%;
  padding-top: 30px;

  ${mediaQueries.mediaQueries.xxl} {
    padding: 0 30px;
  }
  ${mediaQueries.mediaQueries.lg} {
    padding: 0;
  }
`;

export const BoxDetail = styled(Flex)`
  width: 30%;
  padding-bottom: 20px;
  font-size: 20px;
  h2,
  p {
    font-size: 70px;
    margin-right: 25px;
    color: #333333;
    font-weight: 400;
    font-family: ManropeRegular;
  }
  p {
    font-size: 16px;
    line-height: 19px;
    margin-bottom: 10px;
  }

  .cus-line {
    position: relative;
    display: inline-block;
    width: 18px;
    min-width: 18px;
    height: 2px;
    background: #f2e14c;
    margin-right: 20px;
  }
  @media only screen and (max-width: 916px) {
    h2,
    p {
      font-size: 48px;
      margin-right: 18px;
    }
    p {
      font-size: 12px;
      margin-bottom: 0px;
    }
  }
  @media only screen and (max-width: 768px) {
    .Home-services {
      min-height: 0px;
      margin-bottom: 30px;
    }
  }
  @media only screen and (max-width: 744px) {
    p {
      font-size: 10px;
      margin-bottom: 0px;
    }
  }
  @media only screen and (max-width: 560px) {
    width: 50%;
    p {
      font-size: 10px;
      margin-bottom: 0px;
    }
  }
  @media only screen and (max-width: 560px) {
    h2 {
      font-size: 36px;
    }
  }
`;

// security
export const BoxOurValue = styled(Flex)`
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: flex-start;
  padding-top: 60px;
  // background-image: url("/assets/home/backgroundV1.svg");
  background-position: center;
  justify-content: space-between;

  .orbit-flex-sercurity {
    justify-content: space-between;
    & > * {
      width: 30%;
      ${mediaQueries.mediaQueries.md} {
        width: 100%;
      }
    }
  }
`;

export const BoxTitleOurValue = styled(Flex)`
  width: 100%;
  position: relative;
  p {
    position: absolute;
    width: auto;
    top: 50%;
    left: 330px;
    transform: translateY(-50%);
    font-size: 20px;
    font-weight: 400;
    font-family: ManropeRegular;
    color: #303031;
    line-height: 30px;
  }
  h1 {
    font-size: 48px;
    color: #333333;
    font-family: ManropeBold;
    text-transform: uppercase;
    font-weight: 700;
  }
  h3 {
    font-size: 30px;
    color: #333333;
    font-weight: 400;
    font-family: ManropeRegular;
    line-height: 45px;
  }
  @media only screen and (max-width: 1133px) {
    p {
      font-size: 14px;
      line-height: 21px;
    }
  }
  @media only screen and (max-width: 743px) {
    flex-direction: column;
    align-items: flex-start;
    p {
      position: relative;
      left: 0px;
      top: 0px;
      transform: none;
      margin-top: 18px;
    }
  }
`;
/// with technology

export const BoxTechnogyOrbit = styled(Flex)`
  width: 100%;
  height: 100%;
  margin: auto;
  .IndustryExpertiseItem {
    border-radius: 15px;
    border: 1px solid #e7e7e8;
  }
  .IndustryExpertiseIcon {
    height: 86px;
    width: 86px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f7da57;
    border-radius: 20px;
    position: relative;
    z-index: 1;
    :before {
      content: "";
      width: 219%;
      height: 100%;
      position: absolute;
      top: 0%;
      left: 20%;
      background: linear-gradient(
        90deg,
        rgba(247, 218, 87, 0.5) 12.79%,
        rgba(247, 218, 87, 0) 69.15%
      );
      z-index: -1;
    }
  }
  .cus-flex-orbit {
    flex-wrap: wrap;
    & > * {
      padding: 20px 16px 46px;
      border-radius: 6px;
      width: 23.4%;
      background: #fff;
      min-height: 320px;
      margin-bottom: 30px;
    }

    ${mediaQueries.mediaQueries.md} {
      flex-direction: row;
      & > * {
        width: 45%;
        margin: 10px;
        min-height: 315px;
      }
    }

    ${mediaQueries.mediaQueries.sm} {
      & > * {
        width: 100%;
        margin: 10px;
        min-height: auto;
      }
    }
  }
`;

/// our partners
export const BoxPartners = styled(Flex)`
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: flex-start;
  padding-top: 106px;
  padding-bottom: 145px;
  background-image: url("/assets/home/backgroundBlack.svg");
  background-position: center;
  background-color: #333333;
  position: relative;

  ::after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background-image: url("/assets/home/OurPartnersBg.svg");
    background-position: center;
  }
`;

// OurTeam

export const BoxOurTeam = styled(Flex)`
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: flex-start;
  padding-top: 55px;
  padding-bottom: 44px;

  .cus-scroll-bar {
    ::-webkit-scrollbar-thumb {
      display: none;
    }
  }
`;

/// FAQ

export const BoxFaq = styled(Box)`
  width: 100%;
  height: 100%;
  padding-top: 72px;
  padding-bottom: 78px;
  // background-image: url("/assets/home/backgroundV1.svg");
  background-position: center;
  position: relative;
  background-color: #FEFDF5;
  .orbit-faq{
    align-items: flex-start;
  }
    .orbit-faq-panner {
      width: 80%;
      height: 42vw;
      max-height: 426px;
      max-width: 493px;
      background-image: url("${BgFaq}");
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center center;
    }
    // ${mediaQueries.mediaQueries.lg} {
    //   flex-direction: column;
    //   align-items: flex-start;
    //   & > *:nth-child(1) {
    //     width: 100% !important;
    //     margin-top: 0px;
    //   }
    //   & > *:nth-child(3) {
    //     width: 100% !important;
    //   }
    //   .orbit-faq-panner {
    //     position: relative;
    //     bottom: 0 !important;
    //     left: 50%;
    //     transform: translateX(-50%);
    //     width: 48%;
    //   }
    // }
    @media only screen and (max-width: 743px){
      flex-direction: column;
      .orbit-faq{
        flex-direction: column;
      }
      .orbit-faq-panner {
        max-width: 493px;
      }
    }
    @media only screen and (max-width: 540px) {
      .orbit-faq-panner {
        width: 90%;
      }

    }
  }
`;

// box intouch
export const BoxInTouch = styled(Flex)`
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: flex-start;
  padding-top: 84px;
  padding-bottom: 90px;

  .cus-intouch-orbit {
    align-items: flex-start !important;
    position: relative;

    & > * {
      width: 50%;
      position: relative;
    }
    & > *:nth-child(2) {
      min-height: 340px;
    }
    h5 {
      color: #333333;
      font-size: 22px;
      font-weight: 400;
      line-height: 35.2px;
      font-family: ManropeRegular;
      max-width: 547px;
    }
    P {
      margin-left: 16px;
      color: #333333;
      font-size: 26px;
      font-family: ManropeRegular;
      text-decoration: underline;
    }
  }
  @media only screen and (max-width: 1132px){
    padding: 0px;
    padding-top: 64px;
    padding-bottom: 33px;
  }
  @media only screen and (max-width: 1279px) {
    .cus-intouch-orbit {
      h5,
      p {
        font-size: 14px;
        line-height: 18px;
      }
      h5{
        max-width: 386px;
      }
    }
  }
  @media only screen and (max-width: 1132px) {
    .cus-intouch-orbit {
      & > * {
        width: 55%;
        position: relative;
      }
      & > *:nth-child(2) {
        width: 45%;
      }
    }
  }
  @media only screen and (max-width: 743px){
    .cus-intouch-orbit {
      & > * {
        width: 100%;
      }
      & > *:nth-child(2) {
        display: none;
      }
    }
  }
`;

export const OurValue = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  p {
    color: #333333;
    font-size: 16px;
    font-weight: 700;
    font-family: ManropeBold;
    letter-spacing: 4.2px;
    margin-left: 20px;
    text-transform: uppercase;
  }
  @media only screen and (max-width: 1132px) {
    p {
      font-size: 10px;
      margin-left: 10px;
    }
  }
  @media only screen and (max-width: 743px) {
    margin-bottom: 48px;
  }
`;
export const IconOurValue = styled.div`
  width: 68px;
  height: 68px;
  background-color: #f7da57;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const IndustryExpertiseWapper = styled.div`
  width: 100%;
  position: relative;
  // background-image: url("/assets/home/backgroundV1.svg");
  background-color: #fefdf5;
  background-position: center center;
`;
export const IndustryExpertiseTitle = styled.div`
  margin-top: 75px;
  h3 {
    color: #333333;
    font-size: 40px;
    font-weight: 700;
    font-family: ManropeBold;
    margin-bottom: 18px;
  }
  p {
    color: #303031;
    font-size: 20px;
    font-family: ManropeRegular;
    font-weight: 400;
    width: 73%;
    line-height: 23px;
    margin-bottom: 34px;
  }
  @media only screen and (max-width: 768px) {
    p {
      width: 100%;
    }
  }
`;
